import { defineComponent as _defineComponent } from 'vue'
import { inject, ref, Ref } from 'vue'
import alert from '@/store/modules/alert'


export default /*#__PURE__*/_defineComponent({
  __name: 'ShareLiveTrackingDialog',
  props: {
    value: { type: Boolean },
    reservationHash: null
  },
  emits: ['input'],
  setup(__props: any, { emit }) {

const props = __props as {
  value: boolean
  reservationHash: string
};





const trackingLink = inject<Ref<string>>('trackingLink', ref(''))

const copyURL = async () => {
  await navigator.clipboard.writeText(trackingLink.value as string)
  alert.add({
    text: '',
    color: 'green',
    title: 'Link copied',
    dismissible: true,
  })
}

const shareURL = async () => {
  try {
    if (navigator.share) {
      await navigator.share({
        title: 'CharterUP Live Tracking',
        url: location.href,
        text: 'View your CharterUP itinerary and track your vehicle live.'
      })
    } else {
      await copyURL()
    }
  } catch (error) {
    console.error('Error sharing link', error)
  }
}

return { __sfc: true,props, emit, trackingLink, copyURL, shareURL }
}

})